import constants from "../../../../../appConstants";
import {
  mergeUserConfig,
  formatDateTimeWithoutUTCConversion,
} from '@dataGrid/gridUtilities';
import {
  MultiSelectFilter,
  DateTimeFilter,
  StaticFilter,
} from '@dataGrid/components/columnFilters';
import DefectsDetails from "../Defects/DefectsDetails";
import {
  defectsFilterOptions,
  getDefectsFilterValue,
} from "../Defects/DefectsFilter";
import { getDefects, getScacValue } from "../utils/utils";

export default class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = "GridConfiguration";
    this.config = GridConfig.getConfiguration(config);
  }

  static getConfiguration({ showTrailerScacColumn, showTrailerScacValue, userConfig }) {
    const defaultConfig = GridConfig.getDefaultConfiguration(showTrailerScacColumn, showTrailerScacValue);
    return mergeUserConfig({
      defaultConfig,
      userConfig,
    });
  }
  static ManifestNumberRenderer = (params) => {
    if (!params.value) {
      return <span style={{ opacity: 0.5 }}>No Manifest</span>;
    }
    return <span>{params.value}</span>;
  };

  static getDefaultConfiguration(showTrailerScacColumn, showTrailerScacValue) {
    return {
      title: constants.gridNames.TractorGrid,
      keyColumn: "tractorId",
      rowSelection:'single',
      rowDeselection: true,
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
      },
      columns: [
        {
          headerName: "Tractor #",
          headerTooltip: "Tractor #",
          field: "tractorNumber",
          pinned: "left",
          width: constants.columnWidth.W_110,
          minWidth: constants.columnWidth.W_110,
          cellClass: "gridCell-leftAlign",
          lockPosition: true,
          filter: MultiSelectFilter,
          filterParams: {
            filterType: constants.FILTER_TYPES.STRING,
          },
          cellRenderer: GridConfig.TractorNumberRenderer,
        },
        {
          headerName: "SCAC Code",
          headerTooltip: "SCAC Code",
          field: "tractorScac",
          hide: !showTrailerScacColumn,
          isInvisibleInShowHide: !showTrailerScacColumn,
          shouldForceHideColumn: !showTrailerScacColumn,
          filter: MultiSelectFilter,
          width: constants.columnWidth.W_120,
          minWidth: constants.columnWidth.W_120,
          cellClass: "gridCell-leftAlign",
          valueGetter: getScacValue(showTrailerScacValue, 'tractorScac'),
        },
        {
          headerName: "Tractor Status",
          headerTooltip: "Tractor Status",
          field: "tractorStatus",
          filter: MultiSelectFilter,
          width: constants.columnWidth.W_110,
          minWidth: constants.columnWidth.W_110,
          cellClass: "gridCell-leftAlign",
        },
        {
          headerName: "Manifest #",
          headerTooltip: "Manifest #",
          field: "manifestNumber",
          width: constants.columnWidth.W_120,
          minWidth: constants.columnWidth.W_120,
          cellRenderer: GridConfig.ManifestNumberRenderer,
          filter: MultiSelectFilter,
          filterParams: {
            filterType: constants.FILTER_TYPES.STRING,
          },
        },
        {
          headerName: "Current Terminal",
          headerTooltip: "Inbound Terminal",
          field: "inboundTerminal",
          filter: MultiSelectFilter,
          width: constants.columnWidth.W_120,
          minWidth: constants.columnWidth.W_120,
          cellClass: "gridCell-leftAlign",
        },
        {
          headerName: "Domicile Terminal",
          headerTooltip: "Domicile Terminal",
          field: "homeTerminal",
          filter: MultiSelectFilter,
          width: constants.columnWidth.W_120,
          minWidth: constants.columnWidth.W_120,
          cellClass: "gridCell-leftAlign",
        },
        {
          headerName: "Last Updated",
          headerTooltip: "Last Updated",
          field: "lastModifiedDateTs",
          filter: DateTimeFilter,
          filterParams: {
            DATETYPE: constants.DATETYPES.DATETIME,
          },
          width: constants.columnWidth.W_90,
          cellClass: "gridCell-leftAlign",
          valueFormatter: formatDateTimeWithoutUTCConversion,
        },
        {
          headerName: "Defect",
          headerTooltip: "Defect",
          valueGetter: getDefects,
          cellRenderer: DefectsDetails,
          filter: StaticFilter,
          filterParams: {
            staticOptions: defectsFilterOptions,
            getValue: getDefectsFilterValue
          },
          sortable: false,
          width: constants.columnWidth.W_200,
          minWidth: constants.columnWidth.W_200,
          cellClass: "gridCell-leftAlign",
        }
      ],
    };
  }
}
